/**
 * * 全局主题控制器
 */
import { updateCssVariables } from '@/utils/utils'
import StoreController from './store.controller.js'
// * 样式数据
import theme0 from '@/controllers/storeController/models/data/styles/store-theme-0.json'
import theme1 from '@/controllers/storeController/models/data/styles/store-theme-1.json'
import theme2 from '@/controllers/storeController/models/data/styles/store-theme-2.json'

class themeController {
  constructor() {
    themeController.setTheme()
  }

  static async loadTheme(accountType) {
    try {
      const styles = [theme0, theme1, theme2]
      return styles[accountType]
    } catch (e) {
      return {}
    }
  }

  // 主题设置
  static async setTheme() {
    // 门店系统账号信息
    const storeUserInfo = StoreController.storeUserInfo()
    // 根据 accountType 动态加载不同的 样式配置文件
    const themeConfig = await themeController.loadTheme(storeUserInfo.type)
    updateCssVariables(themeConfig)
  }
}

export default themeController
